const api_url = "https://restcountries.com/v3.1";

export { api_url };